import React from "react"

const ContentSection: React.FC = () => {
  return (
    <div className="w-full mx-auto max-w-[1699px] px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
      <div className="max-w-5xl mx-auto">
        {/* Tiêu đề chính */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-gray-800">
          Câu chuyện về Thiền Trúc...
        </h2>

        {/* Đoạn văn đầu tiên */}
        <div className="mb-8 sm:mb-12 text-justify">
          <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
            Giữa nhịp sống thành thị hối hả, Thiền Trúc là nơi bạn có thể chậm
            lại một nhịp, lắng nghe sự tĩnh lặng bên trong mình. Tọa lạc tại
            những con phố yên ả, nhà hàng mang đến một không gian ấm cúng, xanh
            mát, nơi hương thơm cỏ cây hòa cùng tiếng nói nhỏ nhẹ, tạo cảm giác
            thư thả như đang trở về với chính mình.
          </p>
          <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
            Mỗi món chay tại Thiền Trúc là một lời mời gọi quay về với tự nhiên.
            Rau, củ, quả, hạt - tất cả được chọn lựa kỹ lưỡng, chế biến tinh tế
            để giữ trọn sự tươi lành và hương vị nguyên bản. Chúng tôi tin rằng
            khi nguyên liệu được tôn trọng và chế biến với sự chánh niệm, món ăn
            không chỉ nuôi dưỡng thân thể mà còn vỗ về tinh thần.
          </p>
          <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
            Không gian của Thiền Trúc cũng được sắp đặt với dụng ý: nhẹ nhàng,
            giản dị, mang hơi thở thiền. Bạn có thể đến đây một mình tìm sự an
            yên, hay cùng người thân bạn bè tận hưởng những bữa chay thanh tịnh,
            ấm áp.
          </p>
          <p className="text-base sm:text-lg leading-relaxed text-gray-700">
            Chúng tôi mong rằng mỗi bữa ăn ở Thiền Trúc không chỉ là một bữa ăn,
            mà là một khoảng dừng dịu dàng trong ngày để bạn cảm nhận rõ ràng
            hơn món quà tươi đẹp từ thiên nhiên, và cảm nhận sự bình an ngay
            trong từng thìa, từng đũa.
          </p>
        </div>

        {/* Section với hình ảnh và nội dung */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Hình ảnh */}
          <div className="order-1 lg:order-1 flex justify-center">
            <img
              src="./web-ttmi/about/sen-va-truc.png"
              alt="Thiền Trúc - Nơi tiếng gió cũng biết ngồi yên."
              className="w-full max-w-md lg:max-w-full h-auto object-cover"
            />
          </div>

          {/* Nội dung bên phải */}
          <div className="order-1 lg:order-2 text-justify lg:text-left">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-gray-800 text-center lg:text-left">
              Nơi tiếng gió cũng biết ngồi yên.
            </h3>
            <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
              "Thiền" là sự tĩnh lặng, là hơi thở sâu, là khoảnh khắc trở về với
              chính mình. "Trúc" là biểu tượng của sự thanh cao, bền bỉ và bình
              an. Khi đặt tên "Thiền Trúc", chúng tôi gửi gắm một ước mong rằng
              bất cứ ai ghé đến cũng sẽ tìm thấy một khoảng dừng, một nơi để tâm
              an, thân thảnh thơi như đang ngồi dưới bóng trúc mát lành.
            </p>
            <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
              Thiền Trúc không chỉ là một nhà hàng chay, mà còn là không gian
              gợi mở cảm hứng sống chậm, thưởng thức những gì thanh thuần nhất
              từ rau củ, hạt, nấm và gia vị thiên nhiên. Mỗi món ăn được tạo nên
              với sự chăm chút, tỉ mỉ, như một lời mời bạn quay về nuôi dưỡng
              thân – tâm – trí.
            </p>
            <p className="text-base sm:text-lg leading-relaxed text-gray-700">
              Mỗi lần ghé đến, bạn có thể tìm cho mình một góc thật riêng nơi
              chiếc lá rơi chậm hơn, nơi một bữa chay có thể trở thành phút giây
              thiền định dịu dàng.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentSection
